// React & State Management
import { memo } from "react";

// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// API & Constants
import { initialDataWithPagination } from "services/api/consts";
import { PRICE_LIST_SEARCH_COLUMNS } from "./consts";

// Types
import { PriceListSearchResultsProps } from "./types";


const PriceListSearchResults: React.FC<PriceListSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={PRICE_LIST_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(PriceListSearchResults);
